let isDev = false;
let isBeta = false;
let isCbt = true;

let config = {
    dev: {
        apiJavaDomain: "https://java-api-dev.cmbrainbowtv.co.kr",
        apiDomain: "https://devapi.cmbrainbowtv.co.kr",
        smsDomain: "https://java-api-dev.cmbrainbowtv.co.kr",
        devOpsDomain: "https://videothumbnail-dev.cmbrainbowtv.co.kr",
        searchElaUrl:
                "https://search-rainbow-dev-elasticsearch-kjafq6x7qk64ulm5ny5n72vfju.ap-northeast-2.es.amazonaws.com",
        bucketOption: {
            BucketName: "rainbowtv-dev",
            BucketRegion: "ap-northeast-2",
        },
        videoBucketOption: {
            BucketName: "rainbowtv-dev-source71e471f1-y8asegg3fl9w",
            BucketRegion: "ap-northeast-2",
        },
        elasticOption: {
            index: "map_data",
            type: "_doc",
        },
        imageDomain: "https://imagedev.cmbrainbowtv.co.kr",
        videoDomain: "https://voddev.cmbrainbowtv.co.kr",
        videoEncodeApi: "https://awsapi.cmbrainbowtv.co.kr/api/dev/vod",
        javaExcelDomain: 'https://java-api-dev.cmbrainbowtv.co.kr',
        // javaExcelDomain: 'https://jdev-api.cmbrainbowtv.co.kr',
        // javaExcelDomain: 'https://j-api.cmbrainbowtv.co.kr',
        payPhp: 'order/inis/payment/dev',
        cmsDomain: 'https://cms-dev.cmbrainbowtv.co.kr',
        crmDomain: 'https://crm-dev.cmbrainbowtv.co.kr',
        statisticsDomain: 'https://wapi-dev.cmbrainbowtv.co.kr',
        statisticsJavaDomain: "https://stats-dev.cmbrainbowtv.co.kr",
    },
    beta: {
        apiJavaDomain: "https://java-api-beta.cmbrainbowtv.co.kr",
        // 비디오는 개발 서버 바라보고, ela는 실서버 바라봄
        apiDomain: "https://betaapi.cmbrainbowtv.co.kr",
        smsDomain: "https://betaapi.cmbrainbowtv.co.kr",
        searchElaUrl:
                "https://search-rainbow-elasticsearch-gajqptz74cfi54spufymoo27i4.ap-northeast-2.es.amazonaws.com",
        bucketOption: {
            BucketName: "rainbowtv-beta",
            BucketRegion: "ap-northeast-2",
        },
        videoBucketOption: {
            BucketName: "rainbow-tv-beta-source71e471f1-vct3ob92jj3w",
            BucketRegion: "ap-northeast-2",
        },
        elasticOption: {
            index: "map_data",
            type: "_doc",
        },
        imageDomain: "https://imagebeta.cmbrainbowtv.co.kr",
        videoDomain: "https://vodbeta.cmbrainbowtv.co.kr",
        videoEncodeApi: "https://awsapi.cmbrainbowtv.co.kr/api/beta/vod",
        javaExcelDomain: 'https://java-api-beta.cmbrainbowtv.co.kr',
        payPhp: 'order/inis/payment/dev',
        cmsDomain: 'https://cms-beta.cmbrainbowtv.co.kr',
        crmDomain: 'https://crm-beta.cmbrainbowtv.co.kr',
        statisticsDomain: 'https://wapi-dev.cmbrainbowtv.co.kr',
        statisticsJavaDomain: "https://stats-dev.cmbrainbowtv.co.kr",
    },
    prod: {
        apiJavaDomain: "https://java-api.cmbrainbowtv.co.kr",
        apiDomain: "https://apiv2.cmbrainbowtv.co.kr",
        smsDomain: "https://alarmv2.cmbrainbowtv.co.kr",
        searchElaUrl:
                "https://search-rainbow-elasticsearch-gajqptz74cfi54spufymoo27i4.ap-northeast-2.es.amazonaws.com",
        bucketOption: {
            BucketName: "rainbowtv",
            BucketRegion: "ap-northeast-2",
        },
        videoBucketOption: {
            BucketName: "rainbow-tv-prod-source71e471f1-ew1vnpziuig1",
            BucketRegion: "ap-northeast-2",
        },
        elasticOption: {
            index: "map_data",
            type: "_doc",
        },
        imageDomain: "https://image.cmbrainbowtv.co.kr",
        videoDomain: "https://vod.cmbrainbowtv.co.kr",
        videoEncodeApi: "https://awsapi.cmbrainbowtv.co.kr/api/vod",
        javaExcelDomain: 'https://java-api.cmbrainbowtv.co.kr',
        payPhp: 'order/inis/payment/prod',
        cmsDomain: 'https://cms.cmbrainbowtv.co.kr',
        crmDomain: 'https://crm.cmbrainbowtv.co.kr',
        statisticsDomain: 'https://wapi.cmbrainbowtv.co.kr',
        statisticsJavaDomain: "https://stats.cmbrainbowtv.co.kr",
    },
    cbt: {
        apiJavaDomain: "https://cmb-java-api-cbt.hamalab.io",
        apiDomain: "https://cbtapi.cmbrainbowtv.co.kr",
        smsDomain: "https://cbtapi.cmbrainbowtv.co.kr",
        searchElaUrl:
                "https://search-rainbow-elasticsearch-gajqptz74cfi54spufymoo27i4.ap-northeast-2.es.amazonaws.com",
        bucketOption: {
            BucketName: "rainbowtv-cbt-image-hama",
            BucketRegion: "ap-northeast-2",
        },
        videoBucketOption: {
            BucketName: "nia-source71e471f1-qbzuukjjsyxz",
            BucketRegion: "ap-northeast-2",
        },
        elasticOption: {
            index: "map_data",
            type: "_doc",
        },
        imageDomain: "https://imagecbt.cmbrainbowtv.co.kr",
        videoDomain: "https://vodcbt.cmbrainbowtv.co.kr",
        videoEncodeApi: "https://nia-awsapi.hamalab.io/api/cbt/vod",
        javaExcelDomain: "https://cmb-java-api-cbt.hamalab.io",
        payPhp: 'order/inis/payment/cbt',
        cmsDomain: "https://cmb-cms-cbt.hamalab.io",
        crmDomain:'https://crm-beta.cmbrainbowtv.co.kr',
        statisticsDomain: 'https://wapi-cbt.cmbrainbowtv.co.kr',
        statisticsJavaDomain: "https://stats-cbt.cmbrainbowtv.co.kr",
    },
};

function getConfig(key = "apiDomain") {
    if (isCbt) {
        return config.cbt[key];
    } else if (isBeta) {
        return config.beta[key];
    }
    return isDev ? config.dev[key] : config.prod[key];
}

function setConfig(key, value) {
    if (isCbt) {
        config.cbt[key] = value;
    } else if (isBeta) {
        config.beta[key] = value;
    } else if (isDev) {
        config.dev[key] = value;
    } else {
        config.prod[key] = value;
    }
}

let apiDomain = getConfig("apiDomain");
let apiGaURL = `${getConfig("statisticsDomain")}/api/`;
let smsDomain = getConfig("smsDomain");
let devOpsDomain = getConfig("devOpsDomain");
let searchElaUrl = getConfig("searchElaUrl");
let apiJavaURL = `${getConfig("apiJavaDomain")}/api/`;
let apiJavaDomain = `${getConfig("apiJavaDomain")}`;
let apiURL = `${getConfig("apiDomain")}/api/`;
let smsURL = `${getConfig("smsDomain")}/api/`;
let devOpsURL = `${getConfig("devOpsDomain")}/`;
let bucketOption = getConfig("bucketOption");
let imageDomain = getConfig("imageDomain");
let elasticOption = getConfig("elasticOption");
let videoBucketOption = getConfig("videoBucketOption");
let videoEncodeApi = getConfig("videoEncodeApi");
let videoDomain = getConfig("videoDomain");
let javaExcelDomain = getConfig("javaExcelDomain");
let javaExcelApi = `${getConfig('javaExcelDomain')}/`;
let statisticsDomain = `${getConfig('statisticsDomain')}`;
let statisticsJavaDomain = `${getConfig('statisticsJavaDomain')}`;
let statisticsURL = `${getConfig("statisticsDomain")}/api/statistics/`;
let statisticsJavaURL = `${getConfig("statisticsJavaDomain")}/api/`;

let cmsDomain = getConfig("cmsDomain");
let crmDomain = getConfig("crmDomain");

let payPhp = getConfig('payPhp');

let localStorageKey = 'com.dgmonglab.rainbow-cms-admin'

function setterApiDomain(domain) {
    setConfig("apiDomain", domain);
    apiDomain = getConfig("apiDomain");
    apiURL = `${getConfig("apiDomain")}/api/`;
    apiJavaDomain = getConfig("apiJavaDomain");
    apiJavaURL = `${getConfig("apiJavaDomain")}/api/`;
    smsURL = `${getConfig("smsDomain")}/api/`;
    devOpsURL = `${getConfig("devOpsDomain")}/`;
    let devDomain = config.dev.apiDomain;
    let prodDomain = config.prod.apiDomain;
    if (devDomain == domain) {
        isDev = true;
    } else if (prodDomain == domain) {
        isDev = false;
    }
    bucketOption = getConfig("bucketOption");
    searchElaUrl = getConfig("searchElaUrl");
    imageDomain = getConfig("imageDomain");
    elasticOption = getConfig("elasticOption");
    videoBucketOption = getConfig("videoBucketOption");
    videoEncodeApi = getConfig("acceptVideoApi");
    videoDomain = getConfig("videoDomain");
    javaExcelDomain = getConfig("javaExcelDomain");
    javaExcelApi = `${getConfig('javaExcelDomain')}/`;
    statisticsURL = `${getConfig("statisticsDomain")}/api/statistics/`;
    statisticsJavaURL = `${getConfig("statisticsJavaDomain")}/api/`;
    cmsDomain = getConfig("cmsDomain");
    crmDomain = getConfig("crmDomain");
}

export {
    apiURL,
    apiJavaDomain,
    apiJavaURL,
    apiGaURL,
    devOpsURL,
    smsURL,
    apiDomain,
    smsDomain,
    imageDomain,
    setterApiDomain,
    bucketOption,
    searchElaUrl,
    elasticOption,
    videoBucketOption,
    videoEncodeApi,
    videoDomain,
    javaExcelDomain,
    javaExcelApi,
    isDev,
    localStorageKey,
    payPhp,
    isBeta,
    cmsDomain,
    crmDomain,
    statisticsDomain,
    statisticsURL,
    isCbt,
    statisticsJavaURL
};
